// extracted by mini-css-extract-plugin
var _1 = "AddElement__addText--K87zi";
var _2 = "AddElement__circle--ScpNC";
var _3 = "AddElement__icon--cmfsq";
var _4 = "AddElement__main--N2idX";
var _5 = "AddElement__mainDisabled--wzLCC";
export { _1 as "addText", _2 as "circle", _3 as "icon", _4 as "main", _5 as "mainDisabled" }
